import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import './home.scss'
import video from "../Assets/K2BaseCampTrek.mp4"
import Aos from 'aos'
import 'aos/dist/aos.css'
import Slider1 from '../Assets/BarahValley.jpg'
import Slider2 from '../Assets/Batura.jpg'
import Slider3 from '../Assets/HimalayanBrownBear.webp'
import Slider4 from '../Assets/RushLake.jpg'
import Slider5 from '../Assets/Rakaposhi.jpg'
import Slider6 from '../Assets/ShingarlaLake.jpeg'
import Slider7 from '../Assets/K7.jpg'
import Slider8 from '../Assets/LadyFinger.jpeg'
import Slider9 from '../Assets/Masherbrum.jpeg'
import Slider10 from '../Assets/nangaparbat.jpeg'


const Home = () => {

  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])

const sliderImages = [Slider1, Slider2,Slider3,Slider4,Slider5,Slider6,Slider7,Slider8,Slider9,Slider10];


  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % sliderImages.length);
    }, 1000); // change image every 1 second

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <>
      <Helmet>
        <title>World Adventures Tours | Explore Pakistan's Most Beautiful Treks</title>
        <meta name="description" content="Discover breathtaking destinations in Skardu, Hunza, Fairy Meadows and more. Trek with trusted guides and enjoy cultural relaxation across Pakistan." />
        <meta name="keywords" content="Pakistan tours, Skardu, Hunza, K2, trekking, adventure, travel agency, world adventures" />
        <meta name="author" content="World Adventures Tours" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="utf-8" />
      </Helmet>

      <section className='home'>
        <div className="overlay"></div>
        <video src={video} muted autoPlay loop type="video/mp4"></video>

        {/* ===== Slider on top-left ===== */}
        <div className="heroSlider">
          <img src={sliderImages[currentImage]} alt="slider" />
        </div>

        <div className='homeContent container'>
          <div className='textDiv'>
            <span data-aso="fade-up" className='smallText'>
              Let's Explore The Unexpected
            </span>

            <h1 data-aos="fade-up" className='homeTitle'>
              World Adventures Tours
            </h1>
          </div>
        </div>
      </section>
    </>
  )
}

export default Home
